import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { tournoisService, smasheursService } from '../services/api';
import SyncButton from '../components/SyncButton';

const HallOfFame = () => {
  const [tournois, setTournois] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hallOfFame, setHallOfFame] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [tournoisRes, smasheursRes] = await Promise.all([
        tournoisService.getAll(),
        smasheursService.getAll(),
      ]);
      setTournois(tournoisRes.data);

      // Calculer le Hall of Fame
      const stats = {};

      tournoisRes.data.forEach((tournoi) => {
        const smasheurId = tournoi.smasheurId;
        if (!stats[smasheurId]) {
          const smasheur = smasheursRes.data.find(s => s.idPlayerAPI === smasheurId);
          stats[smasheurId] = {
            smasheur: smasheur,
            saucisses: []
          };
        }
        stats[smasheurId].saucisses.push(tournoi);
      });

      // Convertir en array et trier par nombre de victoires
      const sorted = Object.values(stats)
        .filter(item => item.smasheur) // S'assurer que le smasheur existe
        .sort((a, b) => b.saucisses.length - a.saucisses.length);

      // Regrouper par nombre de victoires
      const grouped = {};
      sorted.forEach(item => {
        const count = item.saucisses.length;
        if (!grouped[count]) {
          grouped[count] = [];
        }
        grouped[count].push(item);
      });

      setHallOfFame(grouped);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getMedalIcon = (position) => {
    if (position === 1) return <i className="fa-solid fa-hotdog" style={{ color: 'gold' }}></i>;
    if (position === 2) return <i className="fa-solid fa-hotdog" style={{ color: 'silver' }}></i>;
    if (position === 3) return <i className="fa-solid fa-hotdog" style={{ color: 'saddlebrown' }}></i>;
    return `${position}.`;
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      {tournois.length > 0 ? (
        <>
          <div className="hero-banner">
            <h1 className="hero-title">
              {tournois.length} Saucismash
            </h1>
            <small>ont eu lieu sur Smash Ultimate, voici le Hall of Fame</small>
          </div>

          <div className="container-xl">
            {/* Bouton de synchronisation (s'affiche uniquement si l'API est activée) */}
            <div className="mb-4">
              <SyncButton onSyncComplete={loadData} />
            </div>
            <div className="list-group list-group-flush">
              {Object.keys(hallOfFame)
                .sort((a, b) => b - a) // Trier par nombre de victoires décroissant
                .map((victoryCount, groupIndex) => {
                  const players = hallOfFame[victoryCount];
                  const position = groupIndex + 1;

                  return (
                    <div key={victoryCount}>
                      <div className="mt-4 mb-3">
                        <h3 className="text-center">
                          <span className="badge bg-warning text-dark">
                            {victoryCount} victoire{victoryCount > 1 ? 's' : ''}
                          </span>
                        </h3>
                      </div>

                      {players.map((item) => {
                        const { smasheur, saucisses } = item;

                        return (
                          <div
                            key={smasheur.id}
                            className="list-group-item text-bg-dark border-secondary pb-3 mb-2"
                          >
                            <h4 className="mb-2 text-center">
                              <Link
                                className="link-light text-decoration-none"
                                to={`/smasheurs/${smasheur.id}`}
                              >
                                {smasheur.tag ? `${smasheur.tag} | ` : ''}
                                {smasheur.pseudo}
                              </Link>
                            </h4>
                            <p className="text-center mt-2 mb-0">
                              {saucisses
                                .sort((a, b) => b.numSaucisse - a.numSaucisse)
                                .map((saucisse) => (
                                  <Link
                                    key={saucisse.id}
                                    to={`/tournois/${saucisse.id}`}
                                    className="btn btn-outline-light btn-sm mb-2 me-2"
                                  >
                                    #{saucisse.numSaucisse}
                                  </Link>
                                ))}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      ) : (
        <p className="h1 mt-5 text-center">Pas de saucismash sorry bro</p>
      )}
    </div>
  );
};

export default HallOfFame;